import { useMemo } from 'react'
import { type IntlShape, useIntl } from 'react-intl'
import config from 'constants/config'
import type { OfferTypeId } from 'constants/offerTypesList'
import {
  offerTypeDescriptionMessages,
  offerTypeTitleMessages,
} from 'constants/offerTypesListMessages'
import productLabels from 'i18n/productLabels'

function getLocalizedOfferTypeLabels(
  intl: IntlShape,
  id: OfferTypeId,
): { title: string; description: string } {
  switch (id) {
    case 'hotels':
      return {
        title: intl.formatMessage(productLabels.hotels),
        description: intl.formatMessage(offerTypeDescriptionMessages.hotels),
      }
    case 'tours':
      return {
        title: intl.formatMessage(productLabels.tours),
        description: intl.formatMessage(offerTypeDescriptionMessages.tours),
      }
    case 'cruises':
      return {
        title: intl.formatMessage(offerTypeTitleMessages.cruises),
        description: intl.formatMessage(offerTypeDescriptionMessages.cruises),
      }
    case 'ultra-lux':
      return {
        title: intl.formatMessage(productLabels.ultraLux),
        description: intl.formatMessage(offerTypeDescriptionMessages.ultraLux),
      }
    case 'homes-and-villas':
      return {
        title: intl.formatMessage(offerTypeTitleMessages.homesAndVillas),
        description: intl.formatMessage(offerTypeDescriptionMessages.homesAndVillas),
      }
    case 'experiences':
      return {
        title: intl.formatMessage(offerTypeTitleMessages.experiences),
        description: intl.formatMessage(offerTypeDescriptionMessages.experiences),
      }
    case 'flights':
      return {
        title: intl.formatMessage(offerTypeTitleMessages.flights),
        description: intl.formatMessage(offerTypeDescriptionMessages.flights),
      }
    case 'car-hire':
      return {
        title: intl.formatMessage(offerTypeTitleMessages.carHire),
        description: intl.formatMessage(offerTypeDescriptionMessages.carHire),
      }
  }
}

export function getLocalizedOfferTypesList(intl: IntlShape): Array<App.LocalizedOfferTypeListItem> {
  return config.offerTypesList.map((item) => ({
    ...item,
    ...getLocalizedOfferTypeLabels(intl, item.id as OfferTypeId),
  }))
}

function useLocalizedOfferTypesList(): Array<App.LocalizedOfferTypeListItem> {
  const intl = useIntl()

  return useMemo(() => getLocalizedOfferTypesList(intl), [intl])
}

export default useLocalizedOfferTypesList
